<script setup>
import {useHttpErrorsHandler} from "../../Composables/httpErrorsHandler.js";
import {useRouter} from "vue-router";
import {onBeforeMount, onBeforeUnmount, reactive, ref, watch} from "vue";
import Loader from "../../Components/Loader.vue";
import FormSelectField from "../../Components/FormSelectField.vue";
import {useToast} from "vue-toast-notification";
import FormSelectCenter from "../../Components/FormSelectCenter.vue";
import FormTextarea from "../../Components/FormTextarea.vue";
import FormSelectClient from "../../Components/FormSelectClient.vue";
import FormNumericField from "../../Components/FormNumericField.vue";
import axios from "axios";
import FormDatePicker from "../../Components/FormDatePicker.vue";
import FormTextField from "../../Components/FormTextField.vue";

const $toast = useToast();
const { httpErrorsHandler } = useHttpErrorsHandler();
const router = useRouter();


const loading = ref(false)
const isInitialized = ref(false)
const form = reactive( {
    quote_number: null,
    client_id: null,
    center_id: null,
    quote_date: null,
    valid_until: null,
    comment: null,
    notes: null,
    tax_rate: null,
    currency: null
})
const centerPreSelected = ref([])
const clientPreSelected = ref([])
const errors = ref(null)
function updateQuote() {

    loading.value = true;
    let formData = new FormData();

    Object.entries(form).forEach(([key, value]) => {
        if (typeof value === 'boolean') {
            return formData.append(key, value ? 1 : 0);
        }
        if (value !== null && value !== '') {
            formData.append(key, value);
        }
    });

    formData.append('_method', 'PUT');
    axios.post("/api/quotes/" + router.currentRoute.value.params.id, formData)
        .then(() => {
            $toast.success('Devis modifié avec succès', {
                position: 'top',
                duration: 5000,
                dismissible: true,
                pauseOnHover: true,
            });
            router.back();
        })
        .catch(error => {
            errors.value = error.response.data.errors;
            httpErrorsHandler(error);
            loading.value = false;
        });
}

function getQuote() {
    loading.value = true;
    axios.get("/api/quotes/" + router.currentRoute.value.params.id)
        .then(async response => {
            Object.entries(response.data.data).forEach(([key, value]) => {
                if (key === 'center') {
                    centerPreSelected.value = value;
                    return;
                }
                if (key === 'client') {
                    clientPreSelected.value = value;
                    return;
                }
                if (Object.hasOwn(form, key) && key !== 'address') {
                    form[key] = value;
                }
            });
            loading.value = false;
            isInitialized.value = true;
        })
        .catch(error => {
            httpErrorsHandler(error);
            loading.value = false;
        });
}
onBeforeMount(() => {
    getQuote()
})

//Hide modal if leave page
onBeforeUnmount(() => {
    document.querySelectorAll('.modal').forEach(modalElement => {
        const modalInstance = bootstrap.Modal.getInstance(modalElement);
        if (modalInstance) {
            modalInstance.hide();
        }
    });
})
</script>

<template>
    <div class="row">
        <div class="col-lg-12">
            <!--Loader-->
            <div class="card" v-if="loading">
                <div class="card-body">
                    <loader/>
                </div>
            </div>
        </div>
    </div>
    <!--Form-->
    <form v-on:submit.prevent="updateQuote" v-if="!loading">
        <div class="row">
            <div class="col-lg-6">
                <div class="card">
                    <div class="card-header align-items-center d-flex">
                        <h4 class="card-title mb-0 flex-grow-1"><i class="mdi mdi-file-sign me-2 align-middle fs-4"></i>Informations devis</h4>
                    </div>
                    <div class="card-body">
                        <div class="row">

                            <form-text-field
                                name="quote_number"
                                label="Numéro de devis"
                                :label-hidden="false"
                                @update:field="form.quote_number = $event"
                                :errors="errors"
                                :required="true"
                                :data="form.quote_number"
                                bs-class="col-xl-12"
                                :disabled="true"
                            />


                            <form-select-client
                                :errors="errors"
                                label="Client"
                                name="client_id"
                                :required="true"
                                :data="form.client_id"
                                @update:field="form.client_id = ($event !== null ? $event.id : null)"
                                bs-class="col-xl-6"
                                :disabled="false"
                                :taggable="false"
                                :label-hidden="false"
                                placeholder="Sélectionnez un client"
                                :client-pre-selected="clientPreSelected"
                            />


                            <form-select-center
                                :errors="errors"
                                label="Centre"
                                name="center_id"
                                :required="true"
                                :data="form.center_id"
                                @update:field="form.center_id = ($event !== null ? $event.id : null)"
                                bs-class="col-xl-6"
                                :disabled="false"
                                :taggable="false"
                                :label-hidden="false"
                                placeholder="Sélectionnez un centre"
                                :center-pre-selected="centerPreSelected"
                            />

                            <form-date-picker
                                name="quote_date"
                                label="Date du devis"
                                :label-hidden="false"
                                @update:field="form.quote_date = $event"
                                :errors="errors"
                                :required="true"
                                :data="form.quote_date"
                                bs-class="col-xl-6"
                                :disabled="false"
                            />

                            <form-date-picker
                                name="valid_until"
                                label="Date fin de validité"
                                :label-hidden="false"
                                @update:field="form.valid_until = $event"
                                :errors="errors"
                                :required="true"
                                :data="form.valid_until"
                                bs-class="col-xl-6"
                                :disabled="false"
                            />

                            <form-textarea
                                name="notes"
                                label="Notes internes"
                                :label-hidden="false"
                                @update:field="form.notes = $event"
                                :errors="errors"
                                :required="false"
                                :data="form.notes"
                                bs-class="col-xl-12"
                                :row="1"
                            />

                            <form-textarea
                                name="comment"
                                label="Commentaires"
                                :label-hidden="false"
                                @update:field="form.comment = $event"
                                :errors="errors"
                                :required="false"
                                :data="form.comment"
                                bs-class="col-xl-12"
                                :row="2"
                                information-content="Commentaires visibles sur le devis."
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <!--Financial-->
                <div class="card">
                    <div class="card-header align-items-center d-flex">
                        <h4 class="card-title mb-0 flex-grow-1"><i class="mdi mdi-currency-eur me-2 align-middle fs-4"></i>Informations financières</h4>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <form-numeric-field
                                name="tax_rate"
                                label="Taux de TVA"
                                :label-hidden="false"
                                @update:field="form.tax_rate = $event"
                                :errors="errors"
                                :required="true"
                                :data="form.tax_rate"
                                bs-class="col-md-6"
                                :min="0"
                                :step="0.01"
                                information-content="Taux de TVA en %. Mettre 0 si le client est exonéré de TVA."
                            />

                            <form-select-field
                                name="currency"
                                label="Devise"
                                :label-hidden="false"
                                @update:field="form.currency = $event"
                                :errors="errors"
                                :required="true"
                                :data="form.currency"
                                bs-class="col-md-6"
                                :liste-options="[
                                    { text: 'EUR', value: 'EUR' },
                                ]"
                            />
                            <div class="col-md-12">
                                <!-- Warning IVA changed -->
                                <div class="alert alert-warning alert-border-left alert-dismissible fade shadow show" role="alert">
                                    <i class="ri-alert-line me-3 align-middle"></i> <strong>Attention</strong> - La modification du taux de TVA va lancer le recalcul des montants du devis.
                                    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                                </div>
                            </div>

                            <div class="d-flex gap-2 justify-content-end">
                                <button type="button" class="btn btn-soft-dark" @click="router.back()">Retour</button>
                                <button type="submit" class="btn btn-secondary">Valider</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</template>

<style scoped>

</style>
